import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const userDashboardApi = createApi({
  reducerPath: "userDashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getUserStats: builder.query({
      query: () => ({
        url: "/Stats/summary",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getUserMonthWeekStats: builder.query({
      query: () => ({
        url: "/Stats/docssummary",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getUserCategoryStats: builder.query({
      query: () => ({
        url: "/Stats/docsmacrosummary",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const {
  useGetUserStatsQuery,
  useGetUserMonthWeekStatsQuery,
  useGetUserCategoryStatsQuery,
} = userDashboardApi;
